import React from "react";
import { Grid, Button, withStyles } from "@material-ui/core";

const styles = () => ({
  footer: {
    bottom: 0,
    paddingLeft: 20,
    paddingRight: 20,
  },
  actionContainer: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 20,
    paddingBottom: 20,
  },
  actionButton: {
    textTransform: "none",
    display: "flex",
  },
});

const Action = (props) => {
  const {classes,disableButton}  =props;
  return ( 
    <Grid container className={classes.footer}>
      <Grid item xs={12} classes={{ item: classes.actionContainer }}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          onClick={props.cancel}
          id="closeButton"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          type="submit"
          onClick={props.confirm}
          classes={{
            root: classes.actionButton,
          }}
          disabled={disableButton}
          id={"saveDispatchDriver"}
        >
          Dispatch
        </Button>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Action);
